import { motion } from "framer-motion";
import { Lock, Loader2 } from "lucide-react";

// Stable style / animation objects (module scope) so framer-motion props keep referential identity.
const PAGE_BG = { background: "#071524" };
const CARD_INITIAL = { opacity: 0, y: 16 };
const CARD_ANIMATE = { opacity: 1, y: 0 };
const CARD_TRANSITION = { duration: 0.4 };
const LOCK_BADGE = { background: "#071524", color: "#F7B838" };

export const DashboardLogin = ({ password, onPasswordChange, onSubmit, loading }) => (
  <div className="min-h-screen flex items-center justify-center px-4" style={PAGE_BG}>
    <div className="absolute inset-0 bg-grid-navy opacity-30" aria-hidden="true" />
    <motion.div
      initial={CARD_INITIAL}
      animate={CARD_ANIMATE}
      transition={CARD_TRANSITION}
      className="relative w-full max-w-md rounded-[24px] bg-white p-8 shadow-[0_20px_60px_rgba(0,0,0,0.4)]"
    >
      <div className="flex items-center gap-3">
        <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl" style={LOCK_BADGE}>
          <Lock size={20} />
        </span>
        <div>
          <h1 className="text-xl font-bold text-[#122131]">Registrations Dashboard</h1>
          <p className="text-sm text-[#647384]">Affinity Group · CPF Seminar</p>
        </div>
      </div>
      <form
        className="mt-6"
        onSubmit={(e) => {
          e.preventDefault();
          if (password) onSubmit(password);
        }}
      >
        <label className="block text-sm font-medium text-[#122131] mb-2">Password</label>
        <input
          data-testid="dashboard-password-input"
          type="password"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          placeholder="Enter dashboard password"
          autoFocus
          className="w-full h-12 rounded-xl border border-[rgba(17,42,67,0.18)] px-4 text-[#122131] focus:outline-none focus:border-[#1F9188] focus:ring-2 focus:ring-[rgba(31,145,136,0.15)]"
        />
        <button
          data-testid="dashboard-login-button"
          type="submit"
          disabled={loading}
          className="mt-4 w-full h-12 inline-flex items-center justify-center gap-2 rounded-xl bg-[#F7B838] text-[#071524] font-semibold hover:bg-[#FFD16F] transition-colors disabled:opacity-70"
        >
          {loading ? <Loader2 size={18} className="animate-spin" /> : <Lock size={18} />} Access Dashboard
        </button>
      </form>
      <a href="/" className="mt-5 block text-center text-sm text-[#126F6A] hover:underline">
        ← Back to landing page
      </a>
    </motion.div>
  </div>
);
